var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"inline"}},[_c('badge',{attrs:{"type":_vm.getDeliveryBadgeType()}},[_vm._v(" "+_vm._s(_vm.$t(`PROPERTIES.PROPERTIES_STATUS_${_vm.property.status}`))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }